import { useCallback } from 'react';
import { useCurrentUser } from './useCurrentUser';
import { Roles } from '../Types/interfaces';

export const useHasRole = (): ((role: number) => boolean) => {
  const loggedInUser = useCurrentUser();

  const hasRole = useCallback(
    (role: number) => {
      if (!loggedInUser) return false;
      return (loggedInUser.roles & role) === role;
    },
    [loggedInUser]
  );

  return hasRole;
};

export const useCurrentUserRoles = (): Roles[] => {
  const loggedInUser = useCurrentUser();
  const allAvailableRoles = Object.values(Roles).filter(
    (value) => typeof value === 'number'
  );
  const loggedUserRoles = allAvailableRoles.filter(
    (role) => (loggedInUser.roles & role) === role
  );

  return loggedUserRoles ?? [];
};
